import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=5e4155f8&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=5e4155f8&scoped=true&lang=css&"
import style1 from "./Permission.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4155f8",
  null
  
)

export default component.exports